import type { PolygonJson } from 'contracts/PMIJson';
import type { Color, LineBasicMaterial } from 'three';
import { BufferGeometry, LineLoop, Vector3 } from 'three';

//eslint-disable-next-line no-restricted-imports
import { getLineMaterial } from '../../materials';

//TODO: is a LineLoop the right geometry?
//Or should it be a Mesh?
//* If it should be a Mesh, then it could be created with ShapeGeometry
//  But then the Vector3 needs to be transformed to Vector2 (ShapeGeometry is 2D and can be transformed into 3D space)...
//  * I am assuming that because it is a polygon, that the points are coplanar.
//  * I am wondering if the original data was 2D? and has a transform to locate the planar polygon in 3D?
//    => If so, can the `PolygonJson['polygon']` be refactored to better align with how it would be created in webgl/threejs?
export const parsePolygon = (
  pointsJson: PolygonJson['polygon'],
  color: Color | null,
): LineLoop<BufferGeometry, LineBasicMaterial> => {
  const geometry = new BufferGeometry();
  geometry
    .setFromPoints(pointsJson.map((point) => new Vector3(...point)))
    .computeBoundingBox();
  return new LineLoop(geometry, getLineMaterial(color));
};
